(function () {
  'use strict';

  var page = document.querySelector('[data-infinity-page]');
  if (!page) return;

  function q(selector, root) { return (root || document).querySelector(selector); }
  function qa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  var header = q('[data-infinity-header]');
  function updateHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  var menuButton = q('[data-infinity-menu-button]');
  var mobileNav = q('[data-infinity-mobile-nav]');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', function () {
      var open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
      document.body.classList.toggle('infinity-menu-open', !open);
    });
    mobileNav.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        menuButton.setAttribute('aria-expanded', 'false');
        mobileNav.hidden = true;
        document.body.classList.remove('infinity-menu-open');
      }
    });
  }

  var slides = qa('[data-gallery-slide]');
  var thumbs = qa('[data-gallery-thumb]');
  var currentSlide = 0;
  var lightbox = q('[data-lightbox]');
  var lightboxImage = q('[data-lightbox-image]');

  function pauseVideos(except) {
    qa('video', page).forEach(function (video) {
      if (video !== except) video.pause();
    });
    qa('[data-video-toggle], [data-story-play]').forEach(function (button) {
      button.classList.remove('is-playing');
    });
  }

  function showSlide(index) {
    if (!slides.length) return;
    currentSlide = (index + slides.length) % slides.length;
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === currentSlide);
      slide.setAttribute('aria-hidden', i === currentSlide ? 'false' : 'true');
    });
    thumbs.forEach(function (thumb, i) {
      var active = i === currentSlide;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', String(active));
    });
    var activeVideo = q('video', slides[currentSlide]);
    pauseVideos(activeVideo || null);
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showSlide(parseInt(thumb.getAttribute('data-index'), 10) || 0);
    });
  });
  var prev = q('[data-gallery-prev]');
  var next = q('[data-gallery-next]');
  if (prev) prev.addEventListener('click', function () { showSlide(currentSlide - 1); });
  if (next) next.addEventListener('click', function () { showSlide(currentSlide + 1); });

  qa('[data-light-preview]').forEach(function (button) {
    button.addEventListener('click', function () {
      qa('[data-light-preview]').forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      showSlide(parseInt(button.getAttribute('data-gallery-target'), 10) || 0);
    });
  });

  var productVideo = q('[data-product-video]');
  var videoToggle = q('[data-video-toggle]');
  if (productVideo && videoToggle) {
    videoToggle.addEventListener('click', function () {
      if (productVideo.paused) {
        productVideo.play().catch(function () {});
        videoToggle.classList.add('is-playing');
      } else {
        productVideo.pause();
        videoToggle.classList.remove('is-playing');
      }
    });
    productVideo.addEventListener('click', function () {
      if (productVideo.paused) {
        productVideo.play().catch(function () {});
        videoToggle.classList.add('is-playing');
      } else {
        productVideo.pause();
        videoToggle.classList.remove('is-playing');
      }
    });
  }

  var storyVideo = q('[data-story-video]');
  var storyPlay = q('[data-story-play]');
  if (storyVideo && storyPlay) {
    storyPlay.addEventListener('click', function () {
      if (storyVideo.paused) {
        pauseVideos(storyVideo);
        storyVideo.play().catch(function () {});
        storyPlay.classList.add('is-playing');
        storyPlay.style.opacity = '0';
      } else {
        storyVideo.pause();
        storyPlay.classList.remove('is-playing');
        storyPlay.style.opacity = '';
      }
    });
    storyVideo.addEventListener('click', function () {
      if (storyVideo.paused) {
        storyVideo.play().catch(function () {});
        storyPlay.style.opacity = '0';
      } else {
        storyVideo.pause();
        storyPlay.style.opacity = '';
      }
    });
  }

  var openLightbox = q('[data-open-lightbox]');
  var closeLightbox = q('[data-lightbox-close]');
  if (openLightbox && lightbox) {
    openLightbox.addEventListener('click', function () {
      var activeImage = q('img', slides[currentSlide]);
      if (!activeImage) return;
      lightboxImage.src = activeImage.currentSrc || activeImage.src;
      lightboxImage.alt = activeImage.alt || 'Infinity Cube Lamp enlarged image';
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    });
  }
  if (closeLightbox && lightbox) closeLightbox.addEventListener('click', function () { lightbox.close(); });
  if (lightbox) lightbox.addEventListener('click', function (event) { if (event.target === lightbox) lightbox.close(); });

  var variantData = [];
  var moneyFormat = '${{amount}}';
  try { variantData = JSON.parse(q('#infinity-product-variants').textContent || '[]'); } catch (error) {}
  try { moneyFormat = JSON.parse(q('#infinity-money-format').textContent || '"${{amount}}"'); } catch (error) {}

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';
    var parts = (number / 100).toFixed(precision).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }

  function money(cents) {
    var value = Number(cents || 0);
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholder);
    if (!match) return '$' + formatWithDelimiters(value, 2);
    var amount;
    switch (match[1]) {
      case 'amount_no_decimals': amount = formatWithDelimiters(value, 0); break;
      case 'amount_with_comma_separator': amount = formatWithDelimiters(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': amount = formatWithDelimiters(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': amount = formatWithDelimiters(value, 2, "'", '.'); break;
      default: amount = formatWithDelimiters(value, 2);
    }
    return moneyFormat.replace(placeholder, amount);
  }

  var form = q('#InfinityProductForm');
  var variantInput = q('[data-variant-id]');
  var priceNode = q('[data-product-price]');
  var compareNode = q('[data-product-compare]');
  var savingNode = q('[data-product-saving]');
  var addButton = q('[data-add-to-cart]');
  var addLabel = q('[data-add-label]');
  var addPrice = q('[data-add-price]');
  var buyNow = q('[data-buy-now]');
  var mobilePrice = q('[data-mobile-price]');
  var mobileStock = q('[data-mobile-stock]');
  var mobileAdd = q('[data-mobile-add]');
  var selectedVariant = variantData.find(function (variant) { return String(variant.id) === String(variantInput && variantInput.value); }) || variantData[0];

  function chosenOptions() {
    return qa('[data-option-group]').map(function (group) {
      var checked = q('input:checked', group);
      return checked ? checked.value : '';
    });
  }

  function findVariant() {
    var options = chosenOptions();
    if (!options.length) return selectedVariant || variantData[0];
    return variantData.find(function (variant) {
      return options.every(function (value, index) { return String(variant.options[index]) === String(value); });
    });
  }

  function updateVariant(variant) {
    selectedVariant = variant || null;
    var available = !!(variant && variant.available);
    var price = variant ? money(variant.price) : 'Unavailable';
    if (variantInput) variantInput.value = variant ? variant.id : '';
    if (priceNode) priceNode.textContent = price;
    if (addPrice) addPrice.textContent = price;
    if (mobilePrice) mobilePrice.textContent = price;
    var hasCompare = !!(variant && variant.compare_at_price && variant.compare_at_price > variant.price);
    if (compareNode) {
      compareNode.hidden = !hasCompare;
      compareNode.textContent = hasCompare ? money(variant.compare_at_price) : '';
    }
    if (savingNode) {
      savingNode.hidden = !hasCompare;
      savingNode.textContent = hasCompare ? 'SAVE ' + money(variant.compare_at_price - variant.price) : '';
    }
    if (addButton) addButton.disabled = !available;
    if (buyNow) buyNow.disabled = !available;
    if (mobileAdd) mobileAdd.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to cart' : (variant ? 'Sold out' : 'Unavailable');
    if (mobileAdd) mobileAdd.textContent = available ? 'Add to cart' : (variant ? 'Sold out' : 'Unavailable');
    if (mobileStock) {
      mobileStock.textContent = available ? 'In stock' : (variant ? 'Sold out' : 'Unavailable');
      mobileStock.style.color = available ? '' : '#e0a1a1';
    }
    if (variant && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  qa('[data-option-group]').forEach(function (group) {
    qa('input[type="radio"]', group).forEach(function (input) {
      input.addEventListener('change', function () {
        qa('label', group).forEach(function (label) { label.classList.remove('is-selected'); });
        input.closest('label').classList.add('is-selected');
        var label = q('[data-option-label]', group);
        if (label) label.textContent = input.value;
        updateVariant(findVariant());
      });
    });
  });

  var quantityInput = q('[data-qty-input]');
  function setQty(value) {
    if (!quantityInput) return;
    var min = Number(quantityInput.min || 1);
    var max = Number(quantityInput.max || 10);
    quantityInput.value = Math.max(min, Math.min(max, Number(value) || min));
  }
  var qtyMinus = q('[data-qty-minus]');
  var qtyPlus = q('[data-qty-plus]');
  if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(Number(quantityInput.value) - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(Number(quantityInput.value) + 1); });
  if (quantityInput) quantityInput.addEventListener('change', function () { setQty(quantityInput.value); });

  var toast = q('[data-cart-toast]');
  var toastTimer;
  function showToast() {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.classList.add('is-visible');
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 4200);
  }

  function updateCartCount(count) {
    qa('[data-cart-count]').forEach(function (node) { node.textContent = String(count); });
  }

  function addToCart(goToCheckout) {
    if (!selectedVariant || !selectedVariant.available) return Promise.reject(new Error('Variant unavailable'));
    var quantity = Number(quantityInput && quantityInput.value) || 1;
    if (addButton) addButton.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: quantity }] })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add item'); });
      return response.json();
    }).then(function () {
      if (goToCheckout) {
        window.location.href = '/checkout';
        return;
      }
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (response) { return response.json(); }).then(function (cart) {
        updateCartCount(cart.item_count || 0);
        showToast();
      });
    }).catch(function (error) {
      if (addLabel) addLabel.textContent = error.message || 'Try again';
      setTimeout(function () { updateVariant(selectedVariant); }, 2600);
      throw error;
    }).finally(function () {
      if (addButton) addButton.classList.remove('is-loading');
    });
  }

  if (form) form.addEventListener('submit', function (event) {
    event.preventDefault();
    addToCart(false).catch(function () {});
  });
  if (buyNow) buyNow.addEventListener('click', function () { addToCart(true).catch(function () {}); });
  if (mobileAdd) mobileAdd.addEventListener('click', function () { addToCart(false).catch(function () {}); });

  updateVariant(selectedVariant);
  showSlide(0);
})();
